"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapSync = exports.FabricMapSyncProvider = void 0;
const react_1 = __importStar(require("react"));
const mapbox_gl_sync_move_1 = __importDefault(require("@mapbox/mapbox-gl-sync-move"));
const Context_1 = require("./Context");
/**
 * This hook is responsible for actually maintaining the list of synchronized maps.
 * Its result is passed into the `<MapSyncContext.Provider>`, which client apps then use.
 */
const useMapSyncRaw = () => {
    const [maps, setMaps] = (0, react_1.useState)([]);
    const unsyncMove = (0, react_1.useRef)();
    const addMap = (0, react_1.useCallback)((map) => {
        setMaps((s) => {
            if (s.includes(map)) {
                return s;
            }
            return [...s, map];
        });
    }, []);
    const removeMap = (0, react_1.useCallback)((map) => {
        setMaps((s) => {
            if (!s.includes(map)) {
                return s;
            }
            return s.filter((x) => x !== map);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (unsyncMove.current) {
            unsyncMove.current();
            unsyncMove.current = undefined;
        }
        if (maps.length > 1) {
            unsyncMove.current = (0, mapbox_gl_sync_move_1.default)(...maps);
        }
    }, [maps]);
    return { addMap, removeMap };
};
const MapSyncContext = (0, react_1.createContext)(null);
const useMapSync = () => (0, react_1.useContext)(MapSyncContext);
const FabricMapSyncProvider = ({ children, }) => {
    const value = useMapSyncRaw();
    return (react_1.default.createElement(MapSyncContext.Provider, { value: value }, children));
};
exports.FabricMapSyncProvider = FabricMapSyncProvider;
/**
 * Include this component in a FabricMap (done by default in FabricMapProvider) to make sure that it is synchronized with all other maps.
 *
 * Layers uses the sync functionality to provide compare view.
 *
 * @todo Move actual dual-view and sync logic into this repo.
 */
exports.FabricMapSync = (0, Context_1.withMap)(({ map }) => {
    const { addMap, removeMap } = useMapSync();
    (0, react_1.useEffect)(() => {
        addMap(map);
        return () => removeMap(map);
    }, [map, addMap, removeMap]);
    return null;
});
